
        <div class="qb-hero text-center">
            <h1>
                {{ hero.title }}
            </h1>
            <p class="lead" *ngIf="hero.lead">
                {{ hero.lead }}
            </p>
        </div>
    